
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequiredbdf"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequiredbdf"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("27Lyk", function(module, exports) {

$parcel$export(module.exports, "register", () => $18c11f3350a906ea$export$6503ec6e8aabbaf, (v) => $18c11f3350a906ea$export$6503ec6e8aabbaf = v);
var $18c11f3350a906ea$export$6503ec6e8aabbaf;
var $18c11f3350a906ea$export$f7ad0328861e2f03;
"use strict";
var $18c11f3350a906ea$var$mapping = new Map();
function $18c11f3350a906ea$var$register(baseUrl, manifest) {
    for(var i = 0; i < manifest.length - 1; i += 2)$18c11f3350a906ea$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $18c11f3350a906ea$var$resolve(id) {
    var resolved = $18c11f3350a906ea$var$mapping.get(id);
    if (resolved == null) throw new Error("Could not resolve bundle with id " + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$18c11f3350a906ea$export$6503ec6e8aabbaf = $18c11f3350a906ea$var$register;
$18c11f3350a906ea$export$f7ad0328861e2f03 = $18c11f3350a906ea$var$resolve;

});

var $059280730a898c85$exports = {};

(parcelRequire("27Lyk")).register(new URL("", import.meta.url).toString(), JSON.parse('["iSzgC","index.53bf61ca.js","aRjmo","Planet_B_teaser_ko.4a348320.webp","da0H6","Planet_B_teaser_ja.676098f9.webp","c0NzO","Planet_B_teaser_en.5483fbc4.webp","cWCfc","Planet_B_teaser_zh-cn.61ebdc3e.webp","a4Arc","Planet_B_teaser_zh-tw.2a5cabba.webp","7FrxZ","Planet_B_teaser_ko.25a899a4.webp","8IIjM","Planet_B_teaser_ja.e1c588ae.webp","lqmnn","Planet_B_teaser_en.25f5cca1.webp","iYlLk","Planet_B_teaser_zh-cn.abc8f542.webp","dg4Pn","Planet_B_teaser_zh-tw.3ec37588.webp","1YP0R","recruitment_ko.5935c38a.webp","7g2SI","recruitment_ja.e99a7702.webp","79bru","recruitment_en.1caa9cfb.webp","duT8r","recruitment_zh-cn.69fb5d65.webp","8N6N4","recruitment_zh-tw.d11ff7d9.webp","c4XQG","recruitment_ko.7d460107.webp","9VQ1T","recruitment_ja.ce317c32.webp","2Fion","recruitment_en.a5221b28.webp","dbzKF","recruitment_zh-cn.e2e14b57.webp","7HQaW","recruitment_zh-tw.98723dc9.webp","04juX","faq_button_to_close.6fb96ea5.webp","7YWMn","faq_button_to_open.11769951.webp","gCwN4","faq_content_ko.ce87c524.webp","3qnqi","faq_content_ja.2e55be49.webp","ds8SW","faq_content_en.c208b79e.webp","aM5dN","faq_content_zh-cn.a854a9b3.webp","9S42o","faq_content_zh-tw.2a7610aa.webp","8b7qB","inquiry_ko.6c5cd86d.webp","9gMzD","inquiry_ja.ed9aef2f.webp","iHNNN","inquiry_en.ae9f5d79.webp","hw8fJ","inquiry_zh-cn.a9fe0559.webp","6w5l2","inquiry_zh-tw.93abe5ba.webp","kxsCA","image_ko.9697a3fc.png","37Qhz","image_ja.6e1292d2.png","j2QIL","image_en.7f7f893e.png","cYTDd","image_zh-cn.cf5f0a9f.png","cfjwt","image_zh-tw.42c90122.png","01r9j","back-btn.181e2be9.svg"]'));


let $579d436fe237674f$var$player;
function $579d436fe237674f$var$loadYouTubeAPI() {
    const tag = document.createElement("script");
    tag.src = "https://www.youtube.com/iframe_api";
    const firstScriptTag = document.getElementsByTagName("script")[0];
    firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
}
function $579d436fe237674f$var$onYouTubeIframeAPIReady() {
    $579d436fe237674f$var$player = new YT.Player("yt-player", {
        videoId: "6TFYhR3yCKk",
        playerVars: {
            playsinline: 1
        },
        events: {
            onReady: $579d436fe237674f$var$onPlayerReady
        }
    });
}
function $579d436fe237674f$var$onPlayerReady() {
    document.getElementById("yt-play-button").addEventListener("click", function() {
        document.getElementById("yt-player").style.display = "block";
        $579d436fe237674f$var$player.playVideo();
    });
}
function $579d436fe237674f$export$99fc290d1cb78a6() {
    $579d436fe237674f$var$loadYouTubeAPI();
    window.onYouTubeIframeAPIReady = $579d436fe237674f$var$onYouTubeIframeAPIReady;
}
function $579d436fe237674f$export$692611734b145f0b(languageCode, hasReleaseDatePassed) {
    const videoOverlay = document.getElementById("video-button-overlay");
    if (videoOverlay) {
        const classList = videoOverlay.classList;
        if (classList.length > 1) classList.remove(classList[classList.length - 1]);
        classList.add(hasReleaseDatePassed ? `recruit-${languageCode}` : languageCode);
    }
}


const $bd2abaf2c0009d59$export$8e2a081d6a91a754 = [
    "ko",
    "en",
    "ja",
    "zh-cn",
    "zh-tw"
];
const $bd2abaf2c0009d59$export$d434955a78ed029f = new Date("2024-08-01T01:00:00Z");
const $bd2abaf2c0009d59$export$df406aa2203e9702 = new Date("2024-11-22T10:30:00Z");



var $c82a09c2806b90ea$exports = {};
$c82a09c2806b90ea$exports = new URL("Planet_B_teaser_ko.4a348320.webp", import.meta.url).toString();


var $b91d938995278f61$exports = {};
$b91d938995278f61$exports = new URL("Planet_B_teaser_ja.676098f9.webp", import.meta.url).toString();


var $cc5d8e93b9545287$exports = {};
$cc5d8e93b9545287$exports = new URL("Planet_B_teaser_en.5483fbc4.webp", import.meta.url).toString();


var $6518c8a2b0ffcfba$exports = {};
$6518c8a2b0ffcfba$exports = new URL("Planet_B_teaser_zh-cn.61ebdc3e.webp", import.meta.url).toString();


var $1a170bd238c0864d$exports = {};
$1a170bd238c0864d$exports = new URL("Planet_B_teaser_zh-tw.2a5cabba.webp", import.meta.url).toString();


var $c6280d99029aaaf1$exports = {};
$c6280d99029aaaf1$exports = new URL("Planet_B_teaser_ko.25a899a4.webp", import.meta.url).toString();


var $7d7d926f5b80d377$exports = {};
$7d7d926f5b80d377$exports = new URL("Planet_B_teaser_ja.e1c588ae.webp", import.meta.url).toString();


var $48d34c7772c53902$exports = {};
$48d34c7772c53902$exports = new URL("Planet_B_teaser_en.25f5cca1.webp", import.meta.url).toString();


var $e8da888cc2d11e47$exports = {};
$e8da888cc2d11e47$exports = new URL("Planet_B_teaser_zh-cn.abc8f542.webp", import.meta.url).toString();


var $2562b699daf1a158$exports = {};
$2562b699daf1a158$exports = new URL("Planet_B_teaser_zh-tw.3ec37588.webp", import.meta.url).toString();


var $bebf9c46ace53c1a$exports = {};
$bebf9c46ace53c1a$exports = new URL("recruitment_ko.5935c38a.webp", import.meta.url).toString();


var $354e9f43b2638e04$exports = {};
$354e9f43b2638e04$exports = new URL("recruitment_ja.e99a7702.webp", import.meta.url).toString();


var $adf3b434b681d41b$exports = {};
$adf3b434b681d41b$exports = new URL("recruitment_en.1caa9cfb.webp", import.meta.url).toString();


var $107546352b7aea94$exports = {};
$107546352b7aea94$exports = new URL("recruitment_zh-cn.69fb5d65.webp", import.meta.url).toString();


var $c4007963a34a99b8$exports = {};
$c4007963a34a99b8$exports = new URL("recruitment_zh-tw.d11ff7d9.webp", import.meta.url).toString();


var $9023d8b883fd3172$exports = {};
$9023d8b883fd3172$exports = new URL("recruitment_ko.7d460107.webp", import.meta.url).toString();


var $fa77281bce6aa6de$exports = {};
$fa77281bce6aa6de$exports = new URL("recruitment_ja.ce317c32.webp", import.meta.url).toString();


var $6f48915a7bc3919e$exports = {};
$6f48915a7bc3919e$exports = new URL("recruitment_en.a5221b28.webp", import.meta.url).toString();


var $17f540f9581f2151$exports = {};
$17f540f9581f2151$exports = new URL("recruitment_zh-cn.e2e14b57.webp", import.meta.url).toString();


var $b7274949d4c8da82$exports = {};
$b7274949d4c8da82$exports = new URL("recruitment_zh-tw.98723dc9.webp", import.meta.url).toString();


var $c002dd8e2ebda822$exports = {};
$c002dd8e2ebda822$exports = new URL("faq_button_to_close.6fb96ea5.webp", import.meta.url).toString();


var $151503ccd05cf1f0$exports = {};
$151503ccd05cf1f0$exports = new URL("faq_button_to_open.11769951.webp", import.meta.url).toString();


var $3e9b81ea78dbc539$exports = {};
$3e9b81ea78dbc539$exports = new URL("faq_content_ko.ce87c524.webp", import.meta.url).toString();


var $f6f60ec45da4afa1$exports = {};
$f6f60ec45da4afa1$exports = new URL("faq_content_ja.2e55be49.webp", import.meta.url).toString();


var $6f770b375754eed4$exports = {};
$6f770b375754eed4$exports = new URL("faq_content_en.c208b79e.webp", import.meta.url).toString();


var $c7d015f31d67b64a$exports = {};
$c7d015f31d67b64a$exports = new URL("faq_content_zh-cn.a854a9b3.webp", import.meta.url).toString();


var $9380a50a98b7e911$exports = {};
$9380a50a98b7e911$exports = new URL("faq_content_zh-tw.2a7610aa.webp", import.meta.url).toString();


var $b48aea400d2cb8e3$exports = {};
$b48aea400d2cb8e3$exports = new URL("inquiry_ko.6c5cd86d.webp", import.meta.url).toString();


var $2fe9534aa48a0c69$exports = {};
$2fe9534aa48a0c69$exports = new URL("inquiry_ja.ed9aef2f.webp", import.meta.url).toString();


var $aa7569ea34ee3f2c$exports = {};
$aa7569ea34ee3f2c$exports = new URL("inquiry_en.ae9f5d79.webp", import.meta.url).toString();


var $0d4b7e4b66f39d79$exports = {};
$0d4b7e4b66f39d79$exports = new URL("inquiry_zh-cn.a9fe0559.webp", import.meta.url).toString();


var $3520b0a6f35e8ce8$exports = {};
$3520b0a6f35e8ce8$exports = new URL("inquiry_zh-tw.93abe5ba.webp", import.meta.url).toString();


var $200532b96e9c6973$exports = {};
$200532b96e9c6973$exports = new URL("image_ko.9697a3fc.png", import.meta.url).toString();


var $df562c3b339d18f7$exports = {};
$df562c3b339d18f7$exports = new URL("image_ja.6e1292d2.png", import.meta.url).toString();


var $f1ebcd0420a4efd6$exports = {};
$f1ebcd0420a4efd6$exports = new URL("image_en.7f7f893e.png", import.meta.url).toString();


var $001fd60bc72a4298$exports = {};
$001fd60bc72a4298$exports = new URL("image_zh-cn.cf5f0a9f.png", import.meta.url).toString();


var $4135dc19e41ccd98$exports = {};
$4135dc19e41ccd98$exports = new URL("image_zh-tw.42c90122.png", import.meta.url).toString();


const $6ee9919457b46c3a$export$ac40db7282e7a179 = {
    desktop: {
        ko: (0, (/*@__PURE__*/$parcel$interopDefault($c82a09c2806b90ea$exports))),
        en: (0, (/*@__PURE__*/$parcel$interopDefault($cc5d8e93b9545287$exports))),
        ja: (0, (/*@__PURE__*/$parcel$interopDefault($b91d938995278f61$exports))),
        "zh-cn": (0, (/*@__PURE__*/$parcel$interopDefault($6518c8a2b0ffcfba$exports))),
        "zh-tw": (0, (/*@__PURE__*/$parcel$interopDefault($1a170bd238c0864d$exports)))
    },
    mobile: {
        ko: (0, (/*@__PURE__*/$parcel$interopDefault($c6280d99029aaaf1$exports))),
        en: (0, (/*@__PURE__*/$parcel$interopDefault($48d34c7772c53902$exports))),
        ja: (0, (/*@__PURE__*/$parcel$interopDefault($7d7d926f5b80d377$exports))),
        "zh-cn": (0, (/*@__PURE__*/$parcel$interopDefault($e8da888cc2d11e47$exports))),
        "zh-tw": (0, (/*@__PURE__*/$parcel$interopDefault($2562b699daf1a158$exports)))
    },
    recruiting: {
        ko: (0, (/*@__PURE__*/$parcel$interopDefault($bebf9c46ace53c1a$exports))),
        en: (0, (/*@__PURE__*/$parcel$interopDefault($adf3b434b681d41b$exports))),
        ja: (0, (/*@__PURE__*/$parcel$interopDefault($354e9f43b2638e04$exports))),
        "zh-cn": (0, (/*@__PURE__*/$parcel$interopDefault($107546352b7aea94$exports))),
        "zh-tw": (0, (/*@__PURE__*/$parcel$interopDefault($c4007963a34a99b8$exports)))
    },
    recruitingMobile: {
        ko: (0, (/*@__PURE__*/$parcel$interopDefault($9023d8b883fd3172$exports))),
        en: (0, (/*@__PURE__*/$parcel$interopDefault($6f48915a7bc3919e$exports))),
        ja: (0, (/*@__PURE__*/$parcel$interopDefault($fa77281bce6aa6de$exports))),
        "zh-cn": (0, (/*@__PURE__*/$parcel$interopDefault($17f540f9581f2151$exports))),
        "zh-tw": (0, (/*@__PURE__*/$parcel$interopDefault($b7274949d4c8da82$exports)))
    },
    faq: {
        button: {
            open: (0, (/*@__PURE__*/$parcel$interopDefault($151503ccd05cf1f0$exports))),
            close: (0, (/*@__PURE__*/$parcel$interopDefault($c002dd8e2ebda822$exports)))
        },
        content: {
            ko: (0, (/*@__PURE__*/$parcel$interopDefault($3e9b81ea78dbc539$exports))),
            en: (0, (/*@__PURE__*/$parcel$interopDefault($6f770b375754eed4$exports))),
            ja: (0, (/*@__PURE__*/$parcel$interopDefault($f6f60ec45da4afa1$exports))),
            "zh-cn": (0, (/*@__PURE__*/$parcel$interopDefault($c7d015f31d67b64a$exports))),
            "zh-tw": (0, (/*@__PURE__*/$parcel$interopDefault($9380a50a98b7e911$exports)))
        }
    },
    inquiry: {
        ko: (0, (/*@__PURE__*/$parcel$interopDefault($b48aea400d2cb8e3$exports))),
        en: (0, (/*@__PURE__*/$parcel$interopDefault($aa7569ea34ee3f2c$exports))),
        ja: (0, (/*@__PURE__*/$parcel$interopDefault($2fe9534aa48a0c69$exports))),
        "zh-cn": (0, (/*@__PURE__*/$parcel$interopDefault($0d4b7e4b66f39d79$exports))),
        "zh-tw": (0, (/*@__PURE__*/$parcel$interopDefault($3520b0a6f35e8ce8$exports)))
    },
    mama: {
        ko: (0, (/*@__PURE__*/$parcel$interopDefault($200532b96e9c6973$exports))),
        en: (0, (/*@__PURE__*/$parcel$interopDefault($f1ebcd0420a4efd6$exports))),
        ja: (0, (/*@__PURE__*/$parcel$interopDefault($df562c3b339d18f7$exports))),
        "zh-cn": (0, (/*@__PURE__*/$parcel$interopDefault($001fd60bc72a4298$exports))),
        "zh-tw": (0, (/*@__PURE__*/$parcel$interopDefault($4135dc19e41ccd98$exports)))
    }
};



function $7f49c9907c42a793$export$e49fd432de169a45(languageCode) {
    const gridContainer = document.querySelector(".grid-container");
    gridContainer.className = `grid-container lang-${languageCode}`;
}



function $8ce74b234b807cb3$export$91c34452fd189695(languageCode) {
    const faqButton = document.getElementById("faq-button");
    const faqImageContainer = document.getElementById("faq-image-container");
    const faqImage = document.getElementById("faq-image");
    const helpButton = document.getElementById("help-btn");
    faqButton.src = (0, $6ee9919457b46c3a$export$ac40db7282e7a179).faq.button.open;
    helpButton.src = (0, $6ee9919457b46c3a$export$ac40db7282e7a179).inquiry[languageCode];
    faqImageContainer.style.display = "none";
    let isFAQOpen = false;
    faqButton.addEventListener("click", function() {
        if (!isFAQOpen) {
            faqImage.src = (0, $6ee9919457b46c3a$export$ac40db7282e7a179).faq.content[languageCode];
            faqImageContainer.style.display = "flex";
            faqButton.src = (0, $6ee9919457b46c3a$export$ac40db7282e7a179).faq.button.close;
            faqButton.alt = "Hide FAQ";
            faqImage.onload = function() {
                const containerRect = faqImageContainer.getBoundingClientRect();
                const scrollTarget = window.pageYOffset + containerRect.top + containerRect.height / 2 - window.innerHeight / 2;
                window.scrollTo({
                    top: scrollTarget,
                    behavior: "smooth"
                });
            };
        } else {
            faqImageContainer.style.display = "none";
            faqButton.src = (0, $6ee9919457b46c3a$export$ac40db7282e7a179).faq.button.open;
            faqButton.alt = "FAQ";
            faqButton.scrollIntoView({
                behavior: "smooth"
            });
        }
        isFAQOpen = !isFAQOpen;
    });
}


function $6d2cbc0892556e27$export$9f9a59e54d2dc217(hasReleaseDatePassed) {
    return {
        ep_page_1depth: "poc",
        ep_page_2depth: "cmty",
        ep_page_3depth: "Planet B",
        ep_page_4depth: hasReleaseDatePassed ? "Apply" : "Teaser",
        ep_content_community: "Planet B"
    };
}
function $6d2cbc0892556e27$export$25e7c903a10c41f1(eventName, eventParams = {}) {
    try {
        const sanitizedParams = {};
        for (const [key, value] of Object.entries(eventParams))sanitizedParams[key] = value === null || value === undefined ? "" : String(value);
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
            event: eventName,
            ...sanitizedParams
        });
    } catch (error) {
        console.error("Error sending GTM event:", error);
    }
}
const $6d2cbc0892556e27$export$77e44c771ecf3ff7 = ({ ep_page_1depth: ep_page_1depth, ep_page_2depth: ep_page_2depth, ep_page_3depth: ep_page_3depth, ep_page_4depth: ep_page_4depth })=>`${ep_page_1depth}>${ep_page_2depth}>${ep_page_3depth}>${ep_page_4depth}`;


function $f1344cd7df3dcc6c$export$d2445f1399d5a873(languageCode) {
    window.scrollTo({
        top: 0,
        behavior: "smooth"
    });
    const currentDate = new Date();
    if (currentDate >= (0, $bd2abaf2c0009d59$export$df406aa2203e9702)) {
        // Check if mama wrapper already exists
        const existingMamaWrapper = document.querySelector(".mama-image-wrapper");
        if (existingMamaWrapper) {
            // If exists, update image and button styles
            const image = existingMamaWrapper.querySelector("img");
            const button = existingMamaWrapper.querySelector(".mama-button");
            image.src = (0, $6ee9919457b46c3a$export$ac40db7282e7a179).mama[languageCode] || (0, $6ee9919457b46c3a$export$ac40db7282e7a179).mama["en"];
            button.href = `https://boysplanetapply.com/?locale=${languageCode}`;
            button.className = `mama-button ${languageCode}`;
            return;
        }
        // If not exists, create new wrapper and content
        const newWrapper = document.createElement("div");
        newWrapper.className = "mama-image-wrapper";
        const mainImage = document.createElement("img");
        mainImage.src = (0, $6ee9919457b46c3a$export$ac40db7282e7a179).mama[languageCode] || (0, $6ee9919457b46c3a$export$ac40db7282e7a179).mama["en"];
        const button = document.createElement("a");
        button.href = `https://boysplanetapply.com/?locale=${languageCode}`;
        button.target = "_blank";
        button.className = `mama-button ${languageCode}`;
        newWrapper.appendChild(mainImage);
        newWrapper.appendChild(button);
        document.querySelector(".container").appendChild(newWrapper);
        // Hide old elements
        document.querySelector(".image-wrapper").style.display = "none";
        document.querySelector(".video-button-overlay").style.display = "none";
        document.querySelector(".grid-container").style.display = "none";
        document.querySelector(".faq-container").style.display = "none";
    } else {
        const hasReleaseDatePassed = currentDate >= (0, $bd2abaf2c0009d59$export$d434955a78ed029f);
        const mainImage = document.querySelector(".image-wrapper > img");
        if (mainImage) {
            const commonParams = (0, $6d2cbc0892556e27$export$9f9a59e54d2dc217)(hasReleaseDatePassed);
            const depthString = (0, $6d2cbc0892556e27$export$77e44c771ecf3ff7)(commonParams);
            (0, $6d2cbc0892556e27$export$25e7c903a10c41f1)("screen_view", {
                ...commonParams,
                screen_name: depthString
            });
            const isMobile = window.innerWidth <= 450;
            const imageSet = hasReleaseDatePassed ? (0, $6ee9919457b46c3a$export$ac40db7282e7a179).recruiting : isMobile ? (0, $6ee9919457b46c3a$export$ac40db7282e7a179).mobile : (0, $6ee9919457b46c3a$export$ac40db7282e7a179).desktop;
            mainImage.src = imageSet[languageCode] || imageSet["en"];
            if (hasReleaseDatePassed) {
                (0, $7f49c9907c42a793$export$e49fd432de169a45)(languageCode);
                (0, $8ce74b234b807cb3$export$91c34452fd189695)(languageCode);
            } else [
                "grid-container",
                "faq-container"
            ].forEach((className)=>{
                const element = document.querySelector(`.${className}`);
                if (element) element.style.display = "none";
            });
            (0, $579d436fe237674f$export$692611734b145f0b)(languageCode, hasReleaseDatePassed);
        }
    }
}


const $769e5939a6a11ac7$var$localization = {
    ko: {
        title: "PLANET B | \uACF5\uC2DD \uD648\uD398\uC774\uC9C0 | Mnet",
        description: "Mnet \u2018Boys Planet, Girls Planet, I-LAND \uC2DC\uC98C1 & \uC2DC\uC98C2\u2019 \uC81C\uC791\uC9C4\uC758 \uCD08\uB300\uD615 \uBCF4\uC774 \uADF8\uB8F9 \uC624\uB514\uC158 \uD504\uB85C\uC81D\uD2B8 <PLANET B>",
        ogTitle: "PLANET B | \uACF5\uC2DD \uD648\uD398\uC774\uC9C0 | Mnet",
        ogDescription: `Mnet \u{2018}Boys Planet, Girls Planet, I-LAND \u{C2DC}\u{C98C}1 & \u{C2DC}\u{C98C}2\u{2019} \u{C81C}\u{C791}\u{C9C4}\u{C758} \u{CD08}\u{B300}\u{D615} \u{BCF4}\u{C774} \u{ADF8}\u{B8F9} \u{C624}\u{B514}\u{C158} \u{D504}\u{B85C}\u{C81D}\u{D2B8} <PLANET B>`,
        keywords: "\uD50C\uB798\uB2DB\uBE44, \uD50C\uB798\uB2DB B, \uD50C\uB798\uB2DBB, PLANET B, Mnet \uD50C\uB798\uB2DBB, \uC5E0\uB137 \uD50C\uB798\uB2DBB, Mnet \uC624\uB514\uC158, Mnet \uC11C\uBC14\uC774\uBC8C, PLANET B \uD648\uD398\uC774\uC9C0, PLANET B \uB77C\uC778\uC5C5, PLANET B \uCD9C\uC5F0\uC790, PLANET B \uBC29\uC1A1\uC815\uBCF4, PLANET B \uD648\uD398\uC774\uC9C0, PLANET B \uACF5\uD648, PLANET B \uC601\uC0C1, PLANET B \uD074\uB9BD, PLANET B \uD22C\uD45C, PLANET B \uC9C0\uC6D0, \uD50C\uB798\uB2DBB \uD648\uD398\uC774\uC9C0, \uD50C\uB798\uB2DBB \uB77C\uC778\uC5C5, \uD50C\uB798\uB2DBB \uCD9C\uC5F0\uC790, \uD50C\uB798\uB2DBB \uBC29\uC1A1\uC815\uBCF4, \uD50C\uB798\uB2DBB \uD648\uD398\uC774\uC9C0, \uD50C\uB798\uB2DBB \uACF5\uD648, \uD50C\uB798\uB2DBB \uC601\uC0C1, \uD50C\uB798\uB2DBB \uD074\uB9BD, \uD50C\uB798\uB2DBB \uD22C\uD45C, \uD50C\uB798\uB2DBB \uC9C0\uC6D0, \uBCF4\uC774\uC988\uD50C\uB798\uB2DB, \uAC78\uC2A4\uD50C\uB798\uB2DB, \uBCF4\uC774\uC988\uD50C\uB798\uB2DB2, \uC544\uC774\uB79C\uB4DC, \uC544\uC774\uB79C\uB4DC2, BOYS PLANET, BOYS PLANET2, ILAND, I-LAND, I-LAND2, Girls Planet"
    },
    en: {
        title: "PLANET B | Official Website | Mnet",
        description: "Mnet 'Boys Planet, Girls Planet, I-LAND \uC2DC\uC98C1 & \uC2DC\uC98C2' \uC81C\uC791\uC9C4\uC758 \uCD08\uB300\uD615 \uBCF4\uC774 \uADF8\uB8F9 \uC624\uB514\uC158 \uD504\uB85C\uC81D\uD2B8 <PLANET B>",
        ogTitle: "PLANET B | Official Website | Mnet",
        ogDescription: `From the producers of Mnet's \u{2018}Boys Planet, Girls Planet, and I-LAND Season 1 & Season 2\u{2019}, comes a mega boy group audition project <PLANET B>`,
        keywords: "PLANET B, Mnet PLANET B, Mnet audition, Mnet survival, PLANET B lineup, PLANET B cast, PLANET B broadcast information, PLANET B homepage, PLANET B video, PLANET B clip, PLANET B vote, BOYS PLANET, BOYS PLANET2, ILAND, I-LAND, I-LAND2, Girls Planet"
    }
};
// Function to get URL parameters
function $769e5939a6a11ac7$export$95fd5664a53dd0c5(name) {
    const urlParams = new URLSearchParams(window.location.search);
    return urlParams.get(name);
}
// Function to update meta tags based on locale
function $769e5939a6a11ac7$export$3893bd7a6fa83580(locale) {
    const localizedContent = $769e5939a6a11ac7$var$localization[locale] || $769e5939a6a11ac7$var$localization["en"];
    // Update meta description
    const metaDescription = document.querySelector('meta[name="description"]');
    if (metaDescription) metaDescription.setAttribute("content", localizedContent.description);
    else console.error("Meta tag for description not found");
    // Update Open Graph tags
    const ogTitle = document.querySelector('meta[property="og:title"]');
    if (ogTitle) ogTitle.setAttribute("content", localizedContent.ogTitle);
    else console.error("Meta tag for og:title not found");
    const ogDescription = document.querySelector('meta[property="og:description"]');
    if (ogDescription) ogDescription.setAttribute("content", localizedContent.ogDescription);
    else console.error("Meta tag for og:description not found");
    const keywords = document.querySelector('meta[name="keywords"]');
    if (keywords) keywords.setAttribute("content", localizedContent.keywords);
    else console.error("Meta tag for keywords not found");
    // Update title tag
    const title = document.querySelector("title");
    if (title) title.textContent = localizedContent.title;
    else console.error("Title tag not found");
}


function $d62fe7091d94122e$export$b9ec087097738475() {
    const selectedLang = document.getElementById("selected-lang");
    const dropdownOptions = document.querySelectorAll(".dropdown-option");
    dropdownOptions.forEach((option)=>{
        if (option.textContent === selectedLang.textContent) option.style.color = "white";
        else option.style.color = ""; // Reset to default color
    });
}


function $ef2d0223374c7da0$export$b31b44524efa9c03() {
    if (navigator.languages && navigator.languages.length) return navigator.languages[0].split("-")[0];
    return (navigator.language || navigator.userLanguage).split("-")[0];
}
function $ef2d0223374c7da0$export$80e603050ddd2f3(langCode) {
    const urlParams = new URLSearchParams(window.location.search);
    urlParams.set("locale", langCode);
    window.history.pushState({}, "", `${window.location.pathname}?${urlParams.toString()}`);
}
function $ef2d0223374c7da0$export$52213319c01858f() {
    const urlParams = new URLSearchParams(window.location.search);
    const locale = urlParams.get("locale");
    const pathname = window.location.pathname;
    if (!urlParams.has("locale")) {
        const userLanguage = $ef2d0223374c7da0$export$b31b44524efa9c03();
        const defaultLocale = (0, $bd2abaf2c0009d59$export$8e2a081d6a91a754).includes(userLanguage) ? userLanguage : "en";
        window.location.href = `${pathname}?locale=${defaultLocale}`;
        return;
    }
    if (!(0, $bd2abaf2c0009d59$export$8e2a081d6a91a754).includes(locale)) window.location.href = `${pathname}?locale=en`;
    else $ef2d0223374c7da0$var$setDefaultLanguage(locale);
}
function $ef2d0223374c7da0$var$setDefaultLanguage(langCode) {
    const dropdown = document.getElementById("language-dropdown");
    if (!dropdown) return;
    const selectedLang = dropdown.querySelector("#selected-lang");
    const dropdownOptions = dropdown.querySelectorAll(".dropdown-option");
    let defaultOption = dropdownOptions[0];
    dropdownOptions.forEach((option)=>{
        if (option.getAttribute("data-lang") === langCode) defaultOption = option;
    });
    if (selectedLang) selectedLang.textContent = defaultOption.textContent;
    (0, $f1344cd7df3dcc6c$export$d2445f1399d5a873)(langCode);
    $ef2d0223374c7da0$export$80e603050ddd2f3(langCode);
    (0, $d62fe7091d94122e$export$b9ec087097738475)();
}
function $ef2d0223374c7da0$export$544ea8661fa0df65() {
    const dropdown = document.getElementById("language-dropdown");
    if (dropdown) {
        const dropdownSelect = dropdown.querySelector(".dropdown-select");
        const dropdownOptions = dropdown.querySelectorAll(".dropdown-option");
        const selectedLang = document.getElementById("selected-lang");
        dropdownSelect.addEventListener("click", ()=>dropdown.classList.toggle("active"));
        dropdownOptions.forEach((option)=>{
            option.addEventListener("click", function() {
                const langCode = this.getAttribute("data-lang");
                selectedLang.textContent = this.textContent;
                dropdown.classList.remove("active", "lang-zh-cn");
                if (langCode === "zh-cn") dropdown.classList.add(`lang-${langCode}`);
                (0, $f1344cd7df3dcc6c$export$d2445f1399d5a873)(langCode);
                $ef2d0223374c7da0$export$80e603050ddd2f3(langCode);
                (0, $d62fe7091d94122e$export$b9ec087097738475)();
                (0, $769e5939a6a11ac7$export$3893bd7a6fa83580)(langCode);
            });
        });
        document.addEventListener("click", (event)=>{
            if (!dropdown.contains(event.target)) dropdown.classList.remove("active");
        });
    }
}



function $89a3a1dba1b24509$export$1117968d46e6cacc() {
    const header = document.getElementById("header");
    const headerTop = header.offsetTop;
    window.addEventListener("scroll", ()=>{
        const scrollTop = document.documentElement.scrollTop;
        header.classList.toggle("sticky", scrollTop > headerTop);
        if (scrollTop > headerTop) header.style.backgroundColor = "rgba(21, 24, 27, 0.4)";
        else header.style.backgroundColor = ""; // Reset to default color
    });
}


var $0e48e476f0939a94$exports = {};
$0e48e476f0939a94$exports = new URL("back-btn.181e2be9.svg", import.meta.url).toString();


function $602e63fa246d78eb$export$89dbd0a47fc1f891() {
    const backButtonContainer = document.getElementById("back-button-container");
    const backButton = $602e63fa246d78eb$var$createBackButton();
    backButtonContainer.appendChild(backButton);
}
function $602e63fa246d78eb$export$8e1281e8f640a6ba() {
    const backButtonContainer = document.getElementById("back-button-container");
    if (backButtonContainer) backButtonContainer.style.display = "none";
}
function $602e63fa246d78eb$var$createBackButton() {
    const backButton = document.createElement("img");
    backButton.src = (0, (/*@__PURE__*/$parcel$interopDefault($0e48e476f0939a94$exports)));
    backButton.alt = "Back";
    backButton.className = "back-button";
    backButton.addEventListener("click", $602e63fa246d78eb$var$handleBackButtonClick);
    return backButton;
}
function $602e63fa246d78eb$var$handleBackButtonClick() {
    window.ReactNativeWebView.postMessage('{"command":"close"}');
}




function $f5e5effd96d66274$var$initApp() {
    const locale = (0, $769e5939a6a11ac7$export$95fd5664a53dd0c5)("locale") || "en";
    const isInMnetPlusApp = $f5e5effd96d66274$var$checkMnetPlusApp();
    (0, $ef2d0223374c7da0$export$52213319c01858f)();
    (0, $769e5939a6a11ac7$export$3893bd7a6fa83580)(locale);
    (0, $579d436fe237674f$export$99fc290d1cb78a6)();
    (0, $ef2d0223374c7da0$export$544ea8661fa0df65)();
    (0, $89a3a1dba1b24509$export$1117968d46e6cacc)();
    $f5e5effd96d66274$var$handleBackButton(isInMnetPlusApp);
    // Add click event listeners
    $f5e5effd96d66274$var$addClickEventListeners();
    $f5e5effd96d66274$var$disablePinchZoom();
}
function $f5e5effd96d66274$var$checkMnetPlusApp() {
    console.log("version up");
    return typeof window.MnetPlusApp !== "undefined" && window.MnetPlusApp.startsWith("Mnet Plus/");
}
function $f5e5effd96d66274$var$handleBackButton(isInMnetPlusApp) {
    if (isInMnetPlusApp) (0, $602e63fa246d78eb$export$89dbd0a47fc1f891)();
    else (0, $602e63fa246d78eb$export$8e1281e8f640a6ba)();
}
function $f5e5effd96d66274$var$disablePinchZoom() {
    document.addEventListener("touchstart", function(e) {
        if (e.touches.length > 1) e.preventDefault();
    }, {
        passive: false
    });
    document.addEventListener("touchmove", function(e) {
        if (e.scale && e.scale !== 1) e.preventDefault();
    }, {
        passive: false
    });
}
function $f5e5effd96d66274$var$addClickEventListeners() {
    const currentDate = new Date();
    const hasReleaseDatePassed = currentDate >= (0, $bd2abaf2c0009d59$export$d434955a78ed029f);
    const commonParams = (0, $6d2cbc0892556e27$export$9f9a59e54d2dc217)(hasReleaseDatePassed);
    const mnetPlusLogo = document.querySelector(".header-left a");
    if (mnetPlusLogo) mnetPlusLogo.addEventListener("click", (e)=>{
        e.preventDefault();
        e.stopPropagation(); // Stop the event from bubbling up
        (0, $6d2cbc0892556e27$export$25e7c903a10c41f1)("click_event", {
            ...commonParams,
            ep_button_location: hasReleaseDatePassed ? "PlanetB Apply" : "PlanetB Teaser",
            ep_button_range: "GNB",
            ep_button_name: "Logo"
        });
        setTimeout(()=>{
            window.open("https://mnetplus.world/main", "_blank");
        }, 300);
    });
    // Language dropdown
    document.querySelectorAll(".dropdown-option").forEach((el)=>{
        el.addEventListener("click", (e)=>{
            const langCode = e.target.dataset.lang;
            (0, $6d2cbc0892556e27$export$25e7c903a10c41f1)("click_event", {
                ...commonParams,
                ep_button_location: hasReleaseDatePassed ? "PlanetB Apply" : "PlanetB Teaser",
                ep_button_range: "GNB",
                ep_button_name: `Language_${langCode}`
            });
        });
    });
    // Typeform grid items
    const links = document.querySelectorAll("a.grid-item");
    if (links) // Add click event listener to each link
    links.forEach((link)=>{
        link.addEventListener("click", function(event) {
            event.preventDefault(); // Prevent default link behavior
            // Get the href and language from the link
            const url = this.getAttribute("href");
            const lang = this.getAttribute("data-lang");
            (0, $6d2cbc0892556e27$export$25e7c903a10c41f1)("click_event", {
                ...(0, $6d2cbc0892556e27$export$9f9a59e54d2dc217)(new Date() >= (0, $bd2abaf2c0009d59$export$d434955a78ed029f)),
                ep_button_location: "Home",
                ep_button_range: "Apply Icon",
                ep_button_name: `Apply_${lang}`
            });
            // Open the URL in a new tab
            window.open(url, "_blank");
        });
    });
    // Video play button
    const playButton = document.getElementById("yt-play-button");
    if (playButton) playButton.addEventListener("click", ()=>{
        (0, $6d2cbc0892556e27$export$25e7c903a10c41f1)("click_event", {
            ...commonParams,
            ep_button_location: "Home",
            ep_button_range: "Teaser Video Screen",
            ep_button_name: "Play"
        });
    });
}
document.addEventListener("DOMContentLoaded", $f5e5effd96d66274$var$initApp);


//# sourceMappingURL=index.53bf61ca.js.map
